document.addEventListener('DOMContentLoaded', () => {
  const modals = document.querySelectorAll('.fabric-drawer-modal');
  if (!modals.length) return;

  modals.forEach((modal) => {
    const fabricDetailsContent = modal.querySelector('.fabric-details-content-wrapper');
    const fabricVariantItems = modal.querySelectorAll('.fabric-variant-item');

    if (!fabricDetailsContent || !fabricVariantItems.length) return;

    function updateFabricContent(variantId) {
      const allContents = fabricDetailsContent.querySelectorAll('.fabric-variant-content');
      allContents.forEach((content) => {
        content.classList.add('hidden');
      });

      const selectedContent = fabricDetailsContent.querySelector(`[data-variant-id="${variantId}"]`);
      if (selectedContent) {
        selectedContent.classList.remove('hidden');
      }
    }

    function updateFabricImage(variantId) {
      const imageContainer = modal.querySelector('.fabric-image-container');
      if (!imageContainer) return;

      const images = imageContainer.querySelectorAll('[data-variant-id]');
      images.forEach((img) => {
        img.classList.add('hidden');
      });

      const activeImage = imageContainer.querySelector(`[data-variant-id="${variantId}"]`);
      if (activeImage) {
        activeImage.classList.remove('hidden');
      }
    }

    function updateAvailableColors(selectedOptions) {
      const variantSelects = document.querySelector('variant-selects');
      if (!variantSelects || !fabricVariantItems.length) return;

      const variantsScript = variantSelects.querySelector('script[type="application/json"]');
      if (!variantsScript) return;

      try {
        const variants = JSON.parse(variantsScript.textContent);

        fabricVariantItems.forEach((item) => {
          const colorValue = item.getAttribute('data-color-value');
          let hasMatchingVariant = false;

          for (const variant of variants) {
            if (!variant.options) continue;

            const hasColor = variant.options.some((opt) => opt === colorValue);
            if (!hasColor) continue;

            let matchesOtherOptions = true;
            for (let i = 0; i < variant.options.length; i++) {
              if (variant.options[i] === colorValue) continue;
              if (selectedOptions[i] && variant.options[i] !== selectedOptions[i]) {
                matchesOtherOptions = false;
                break;
              }
            }

            if (matchesOtherOptions && variant.options.includes(colorValue)) {
              hasMatchingVariant = true;
              item.setAttribute('data-variant-id', variant.id);
              break;
            }
          }

          if (hasMatchingVariant) {
            item.style.display = '';
            item.style.opacity = '1';
          } else {
            item.style.display = 'none';
          }
        });
      } catch (e) {
        console.error('Error updating available colors:', e);
      }
    }

    fabricVariantItems.forEach((item) => {
      item.addEventListener('click', () => {
        const variantId = item.getAttribute('data-variant-id');
        if (!variantId) return;

        fabricVariantItems.forEach((i) => {
          i.classList.remove('active');
          i.setAttribute('aria-pressed', 'false');
        });
        item.classList.add('active');
        item.setAttribute('aria-pressed', 'true');

        updateFabricContent(variantId);
        updateFabricImage(variantId);
      });

      item.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          item.click();
        }
      });
    });

    const firstItem = Array.from(fabricVariantItems).find(
      (el) => el.getAttribute('data-variant-id')
    );
    if (firstItem) {
      firstItem.classList.add('active');
      firstItem.setAttribute('aria-pressed', 'true');
      updateFabricImage(firstItem.getAttribute('data-variant-id'));
      updateFabricContent(firstItem.getAttribute('data-variant-id'));
    }

    document.addEventListener('product:variant-change', (event) => {
      if (!event.detail || !event.detail.variant) return;

      const variantId = event.detail.variant.id;
      updateFabricContent(variantId);
      updateFabricImage(variantId);

      if (event.detail.variant.options) {
        updateAvailableColors(event.detail.variant.options);
      }

      const matchingItem = Array.from(fabricVariantItems).find(
        (i) => i.getAttribute('data-variant-id') == variantId
      );

      if (matchingItem) {
        fabricVariantItems.forEach((i) => {
          i.classList.remove('active');
          i.setAttribute('aria-pressed', 'false');
        });
        matchingItem.classList.add('active');
        matchingItem.setAttribute('aria-pressed', 'true');
      }
    });

    const variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
      const variantsScript = variantSelects.querySelector('script[type="application/json"]');
      if (variantsScript) {
        try {
          const variants = JSON.parse(variantsScript.textContent);
          if (variants && variants[0] && variants[0].options) {
            updateAvailableColors(variants[0].options);
          }
        } catch (e) {
          console.error('Error initializing available colors:', e);
        }
      }
    }

    modal.addEventListener('click', (event) => {
      if (event.target === modal && typeof modal.hide === 'function') {
        modal.hide();
      }
    });
  });
});

